import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_MT',
  {
    fdidYouMean: true,
    ffacetNavigation: true,
    fdomainSuggestions: true,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: false,
  },
  'b8ce68f3-cb9f-492c-ab88-1c1e211568f3',
  ''
);
